import { render } from "./ServersCard.vue?vue&type=template&id=727d2334&ts=true"
import script from "./ServersCard.vue?vue&type=script&lang=ts"
export * from "./ServersCard.vue?vue&type=script&lang=ts"

import "./ServersCard.vue?vue&type=style&index=0&id=727d2334&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__